import { render, staticRenderFns } from "./Atms.vue?vue&type=template&id=2ff92ac0&"
import script from "./Atms.vue?vue&type=script&lang=ts&"
export * from "./Atms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports